<template>
  <div class="topcss">
    <header>
      <div class="container">
        <div class="row">
          <div class="col bright-pre-header-item-left">
            <div class="float-left">
              <a href="/" class="custom-logo-link" rel="home" itemprop="url">
                <img
                  src="../../assets/images/NuevoLogoIbero.png"
                  class="custom-logo"
                  alt="Corporación Universitaria Iberoamericana"
                  itemprop="logo"
                />
              </a>
            </div>
            <div class="float-right">
                <menuibero msg="IberoMenu"/>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="bright-page-title-area">
      <div class="bright-page-title">
        <div class="container">
          <h1 class="entry-title" v-text="this.$route.meta.title" />          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuibero from '@/views/layout/Menu.vue'

export default {
  name: 'IberoMenu',
  components: {
    menuibero
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
.bright-pre-header {
  background: #fff;
  color: #000;
  padding: 10px 0; 
  border-bottom: 1px solid black;
}
.fa {
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.custom-logo-link img
{
  width: 180px;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.fa-map-marker
{
  font-family: 'Montserrat', sans-serif;
}

.nav-link
{
  font-family: 'Montserrat', sans-serif !important;
}

.quick-contacts span a
{
  color: #000;
  font-family: 'Montserrat', sans-serif;
}

.quick-contacts span a:hover
{
  color: #f2a900;
}

.fa, .fa-stack {
  display: inline-block;
}
.fa-map-marker:before {
  content: "\f041";
}
.fa-phone:before {
  content: "\f095";
}
.fa-envelope:before {
  content: "\f0e0";
}
</style>